import React, { useEffect } from "react";
import { Table, Tooltip, Image } from "antd";
import { ColumnsType } from "antd/es/table";
import { useIntroductionsModel } from "../introductionsModel";
import { IIntroductionsDetail } from "../introductionsService";
import { getBaseRequestUrl, getToken, getFileUrl } from "@/utils/constants";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useIntroductionsModel();

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IIntroductionsDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '业务名称',
            width: 160,
            dataIndex: 'name',
            fixed: "left",
        }, {
            title: '业务图片',
            width: 80,
            dataIndex: 'photo',
            className: "p-0",
            render: (text, record) => record.photo ? <Image src={getFileUrl(record.photo.split(",")[0])} style={{ width: "40px", height: "40px", marginRight: "10px" }} /> : ""
        }, {
            title: '业务介绍',
            width: 180,
            dataIndex: 'profiles',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>,
        },
        {
            title: '二维码',
            width: 160,
            dataIndex: 'qrCode',
            className: "p-0",
            render: (text, record) => record.qrCode ? <Image src={getFileUrl(record.qrCode)} style={{ width: "40px", height: "40px", marginRight: "10px" }} /> : ""
        },
        {
            title: '创建人',
            width: 120,
            dataIndex: 'createUser',
            align: "center"
        },
        {
            title: '创建时间',
            width: 180,
            dataIndex: 'createTime',
        }

    ];


    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id ?? ""}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId] as string[])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id ?? ""),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id ?? ""),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id ?? ""]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}